module.exports = __webpack_public_path__ + "static/media/leftLine1.7c707edd.svg";